// @flow
import type { Node } from 'react';
import React from 'react';

import styles from './cardHeaderRightGroup.css';


type CardHeaderRightGroupPropTypes = {
  children?: Node,
  clearPadding?: boolean,
};

const CardHeaderRightGroup = ({
  children,
  clearPadding = false,
}: CardHeaderRightGroupPropTypes) => (
  <div className={`${styles.headerRightGroup} ${clearPadding ? styles.clearPadding : ''}`}>
    { children }
  </div>
);

export default CardHeaderRightGroup;



// WEBPACK FOOTER //
// ./src/scripts/components/CardHeaderRightGroup/index.jsx